// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionArticle_articleMain__Px7Rw","noSidePaddings":"SectionArticle_noSidePaddings__beSoj"};